import { ELevelResult } from 'Shared/types';
import selectorsGLR from './glr/glr';
import selectorsVLR from './vlr/vlr';
import selectorsPLR from './plr/plr';
const selectors = {
    [ELevelResult.Gene]: selectorsGLR,
    [ELevelResult.Variant]: selectorsVLR,
    [ELevelResult.Phenotype]: selectorsPLR,
};
export const getSelectors = (levelResult) => selectors[levelResult];
